<template>
  <div>
    <div class="menuTool" style="width:100%;">
          <el-form :inline="true" label-position="right" label-width="100px" :model="query">
                <el-form-item label="表号">
                    <el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
                </el-form-item>
                <el-form-item label="实际表号">
                    <el-input size="small" v-model="query.actualNo" placeholder="请输入实际表号" clearable></el-input>
                </el-form-item>
                <el-form-item label="账单号">
                    <el-input size="small" v-model="query.no" placeholder="请输入账单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="仪表类型">
                    <el-select  clearable size="small" v-model="query.meterType" placeholder="仪表类型" >
                        <el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否智能表" >
                    <el-select  clearable size="small" v-model="query.autoFlag" placeholder="是否智能表" >
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="调整状态">
                    <el-select  clearable size="small" v-model="query.deductionStatus" placeholder="使用状态" >
                    <el-option v-for="item in deductionStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="调整时间" >
                    <el-date-picker
                    v-model="formData.dataRange"
                    type="daterange"
                    align="right"
                    size="small"
                    style="width: 410px"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="button-tool">
                <el-button size="small" type="primary" @click="doSearch">查询</el-button>
                <el-button size="small" type="primary" @click="doExport">导出</el-button>
                <el-button size="small" type="primary" @click="doImport">手抄调整导入</el-button>
                <el-button size="small" type="primary" @click="doFinanceAudit">财务审核</el-button>
                <el-button size="small" type="primary" @click="doConfirmAdjust">确认调整</el-button>
            </div>

        <el-table  
        :data="overviewData"
        row-key="status" 
        style="margin: 20px 0px"
        border>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="alreadyGenerate" label="已生成账单"></el-table-column>
            <el-table-column prop="finance" label="财务审核"></el-table-column>
            <el-table-column prop="finished" label="调整完成"></el-table-column>
            <el-table-column prop="sumPrice" label="总价"></el-table-column>
        </el-table>

        <el-table  
        :data="tableData"  
        @selection-change="handleSelectionChange" 
        row-key="id" 
        border
        :stripe="true">
            <el-table-column width="55" fixed="left" type="selection"></el-table-column>
            <el-table-column width="200" prop="payMeterNo" label="表号"></el-table-column>
            <el-table-column width="250" prop="actualNo" label="实际表号"></el-table-column>
            <el-table-column width="160" prop="meterType" label="类型"></el-table-column>
            <el-table-column width="160" prop="autoFlagStr" label="是否智能"></el-table-column>
            <el-table-column width="160" prop="no" label="账单号"></el-table-column>
            <el-table-column width="160" prop="deductionAmount" label="应调整金额"></el-table-column>
            <el-table-column width="160" prop="deductionIngAmount" label="已调整金额"></el-table-column>
            <el-table-column width="160" prop="adjustUse" label="调整使用量"></el-table-column>
            <el-table-column width="160" prop="accrualDate" label="调整日期"></el-table-column>
            <el-table-column width="160" prop="accrualDateStart" label="调整开始时间"></el-table-column>
            <el-table-column width="160" prop="accrualDateEnd" label="调整结束时间"></el-table-column>
            <el-table-column width="160" prop="feeitemName" label="收费项"></el-table-column>
            <el-table-column width="100" prop="deductionReason" label="调整原因"></el-table-column>
            <el-table-column width="100" prop="deductionFlagStr" label="调整状态"></el-table-column>
            <el-table-column width="100" prop="createDate" label="创建时间"></el-table-column>
            <el-table-column width="100" prop="createByStr" label="创建人"></el-table-column>
            <el-table-column width="100" prop="auditDate" label="审核时间"></el-table-column>
            <el-table-column width="100" prop="auditByStr" label="审核人"></el-table-column>
            <el-table-column width="200" fixed="right" label="操作" >
            <template slot-scope="scope">
                <el-button @click="doEdit(scope.row)" type="text" size="small">修改</el-button>
                <el-button @click="doDel(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.page"
        :page-sizes="[10, 20, 40, 50]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next"
        :total="pagination.total"
        style="float: right; margin: 10px 0px;">
        </el-pagination>

        <el-dialog
        :title="importDlg.title"
        width="400px"
        @close="() => importDlg.visible"
        :visible.sync="importDlg.visible"
        >
            <upload-excel 
            :uploadUrl='importDlg.uploadUrl'
            :templateUrl='importDlg.templateUrl'
            ></upload-excel>
        </el-dialog>

        <el-dialog
        :title="editDlg.title"
        width="600px"
        :visible.sync="editDlg.visible"
        center
        >
            <el-form :inline="true" label-position="right" label-width="100px" :model="editDlg.formData">
                <el-form-item label="表号">
                    <el-input size="small" v-model="editDlg.formData.payMeterNo" placeholder="请输入表号" clearable></el-input>
                </el-form-item>
                <el-form-item label="电表类型">
                    <el-input size="small" v-model="editDlg.formData.meterType" placeholder="请输入电表类型" clearable></el-input>
                </el-form-item>
                <el-form-item label="账单号">
                    <el-input size="small" v-model="editDlg.formData.no" placeholder="请输入账单号" clearable></el-input>
                </el-form-item>
                <el-form-item label="应抵金额">
                    <el-input size="small" v-model="editDlg.formData.deductionAmount" placeholder="请输入应抵金额" clearable></el-input>
                </el-form-item>
                <el-form-item label="已抵金额">
                    <el-input size="small" v-model="editDlg.formData.deductionIngAmount" placeholder="请输入已抵金额" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="应收日期">
                    <el-input size="small" v-model="editDlg.formData.accrualDate" placeholder="请选择应收日期" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="抵扣原因">
                    <el-input size="small" v-model="editDlg.formData.deductionReason" placeholder="请输入抵扣原因" clearable></el-input>
                </el-form-item>
                <el-form-item label="收费项目">
                    <el-input size="small" v-model="editDlg.formData.meterItemName" placeholder="请输入收费项目" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="doSave()">保 存</el-button>
                <el-button @click="editDlg.visible = false">取 消</el-button>
            </span>
        </el-dialog>

    </div>
  </div>
</template>
<script>
import '@/assets/scss/common.scss';
import {deductionStatus, options, meterType} from "@/dict/meterDict";
import mixin from '@/mixin';
import _ from 'lodash';
import UploadExcel from '@/components/UploadExcel.vue';
import { get, post, del, put, download } from "@/assets/common/request";

export default {
  name: "MeterDeduction",
  components: { UploadExcel },
  mixins: [mixin],
  data() {
    return {
        formData: {},
        deductionStatus,
        options,
        meterType,
        diaLogVisible: false,
        queryListUrl: '/meter/web/deduction/page',
        overviewData: [
            {
                'status': '金额',
                'alreadyGenerate': 0,
                'finance': 0,
                'finished': 0,
                'sumPrice': 0
            }
        ],
        importDlg: {
            title: '',
            visible: false,
            uploadUrl: '',
            templateUrl: '',
        },
        editDlg: {
            title: '',
            visible: false,
            id: '',
            formData: {}
        }
    }
  },
  methods: {
    doSearch() {
        this.getList(); 
    },
    doExport() {
        const title = '收费调整数据';
        const url = 'meter/deduction/export';
        this._export(title, url);
    },
    doImport() {
        this.importDlg = {
            title: '手抄调整数据导入',
            visible: true,
            uploadUrl: 'meter/web/deduction/import',
            templateUrl: 'meter/web/deduction/template'
        }
    },
    doFinanceAudit() {
        const that = this;
        if(that.checkSelection()) {
            const ids = that.getSelectionIds();
            const url = '/meter/web/deduction/audit';
            const data = {ids};
            that._post(url, data);
        }
    },
    doConfirmAdjust() {
        const that = this;
        if(that.checkSelection()) {
            const ids = that.getSelectionIds();
            const url = '/meter/web/deduction/confirm';
            const data = {ids};
            that._post(url, data);
        }
    },
    doSum() {
        const url = '/meter/web/deduction/sum';
        get(url, {}, data => {
            let sumPrice = 0;
            for(let item of data) {
                sumPrice += item['deduction_amount'];
                if(item['deduction_flag'] == 0) {
                    this.overviewData[0]['alreadyGenerate'] = item['deduction_amount'];
                }else if(item['deduction_flag'] == 1) {
                    this.overviewData[0]['finance'] = item['deduction_amount'];
                }else if(item['deduction_flag'] == 3) {
                    this.overviewData[0]['finished'] = item['deduction_amount'];
                }
            }
            this.overviewData[0]['sumPrice'] = sumPrice;
        });
    },
    doEdit(row) {
        this.editDlg.formData = {};
        this.editDlg.id = row.id;
        const url = `/meter/web/deduction/${row.id}`;
        get(url, {}, data => {
            this.editDlg.formData = data;
        });
        this.editDlg.visible = true;
    },
    doSave() {
        const url = `/meter/web/deduction/{this.editDlg.id}`;
        const data = _pick(this.editDlg.formData, ['payMeterNo', 'meterType', 'no', 'deductionAmount', 'deductionIngAmount', 'accrualDate', 'deductionReason', 'meterItemName'])
        post(url, data);
    },
    doDel(row) {
        const url = `/meter/web/deduction/${row.id}`;
        del(url);
    },
  },
  mounted() {
      this.getList();
      this.doSum();
  }
}
</script>